import { Button } from "@material-ui/core";
import STBoardDetail from "../../../assets/styles/organisms/boardDetail.module.scss";
import { useBoard } from "../../../providers/BoardDetailProvider";
import { useContext, useEffect, useState } from "react";
import { SiteContext } from "../../../providers/SiteProvider";

const BoardTotalOfComment = () => {
  const {
    state: { totalComments, boardDetailData },
  } = useBoard();
  const { comment_flg = 0 } = boardDetailData ?? {};
  const [commentFlag, setCommentFlag] = useState(
    Boolean(comment_flg && totalComments)
  );
  const site = useContext(SiteContext);
  const mainColor = site.mainColor;
  useEffect(() => {
    setCommentFlag(Boolean(comment_flg && totalComments));
  }, [comment_flg, totalComments]);

  return (
    <div className={STBoardDetail.boardFooterComments}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="10"
        viewBox="0 0 12 10"
        fill="none"
      >
        <path
          d="M1.33317 1H10.6665V7H2.01567L1.33317 7.585V1ZM1.33317 0C0.691504 0 0.172337 0.45 0.172337 1L0.166504 10L2.49984 8H10.6665C11.3082 8 11.8332 7.55 11.8332 7V1C11.8332 0.45 11.3082 0 10.6665 0H1.33317ZM2.49984 5H7.1665V6H2.49984V5ZM2.49984 3.5H9.49984V4.5H2.49984V3.5ZM2.49984 2H9.49984V3H2.49984V2Z"
          fill={commentFlag ? mainColor : "#999999"}
        />
      </svg>
      <Button
        style={{
          padding: 0,
          width: "fit-content",
          minWidth: "fit-content",
        }}
      >
        <span>{totalComments}</span>
      </Button>
    </div>
  );
};

export default BoardTotalOfComment;
